import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";
import type { Profile } from "@/types/models";

export interface IProfileRepository {
  getById(id: string): Promise<Profile | null>;
  upsert(input: { id: string; fullName?: string; role?: string }): Promise<Profile>;
}

export class ProfileRepository implements IProfileRepository {
  constructor(private readonly client: SupabaseClient<Database>) {}

  async getById(id: string): Promise<Profile | null> {
    const { data, error } = await this.client
      .from("profiles")
      .select("*")
      .eq("id", id)
      .maybeSingle();

    if (error) throw new Error(error.message);
    if (!data) return null;
    return this.mapRow(data);
  }

  async upsert(input: { id: string; fullName?: string; role?: string }): Promise<Profile> {
    const { data, error } = await this.client
      .from("profiles")
      .upsert({ id: input.id, full_name: input.fullName ?? null, role: input.role ?? "customer" })
      .select()
      .single();

    if (error) throw new Error(error.message);
    return this.mapRow(data);
  }

  private mapRow(row: Database["public"]["Tables"]["profiles"]["Row"]): Profile {
    return {
      id: row.id,
      fullName: row.full_name,
      role: row.role,
      createdAt: row.created_at,
    };
  }
}
